module.exports = __webpack_public_path__ + "img/banner2_9_vi.d3914211.png";